import HomePage from './pages/Home';
import AirportTransfersPage from './pages/AirportTransfersPage';
import BusinessTaxiPage from './pages/BusinessTaxiPage';
import FamilyAirportTaxiPage from './pages/FamilyAirportTaxiPage';
import CoachesPage from './pages/CoachesPage';
import BusinessTravelManagementPage from './pages/BusinessTravelManagementPage';
import BerbusPage from './pages/BerbusPage';
import Tours from './pages/Tours';
import Orders from './pages/Users/Orders';
import EditInvoice from './pages/Users/EditInvoice';
import UserData from './pages/Users/Data';
import Auth from './pages/Auth';
import PasswordReset from './pages/PasswordReset';
import Layout from './layouts/Layout';
import Register from './pages/Register';
import BusinessRegister from './pages/BusinessRegistration';
import store from './store';

const preventCompany = (next) => {
    if (store.getters['user/isCompany']) {
        next({ name: 'home.index' });
    } else {
        next();
    }
};

const preventNotLoggedIn = (next) => {
    if (!store.getters['user/isLoggedIn']) {
        next({name: 'home.index'});
    } else {
        next();
    }
};

export default [
    {
        path: '/',
        name: 'layout',
        component: Layout,
        children: [
            { path: '/', name: 'home.index', component: HomePage.Index },
            { path: '/login', name: 'login.index', component: Auth.Login },
            { path: '/login/admin', name: 'login.admin', component: Auth.LoginAdmin },
            { path: '/reset-password/:token', name: 'password-reset.reset', component: PasswordReset.Reset },
            { path: '/password/reset', name: 'password-reset.index', component: PasswordReset.Index },
            { path: '/register', name: 'register.index', component: Register.Index },
            { path: '/register/confirm/:email?', name: 'register.confirm', component: Register.Confirm },
            { path: '/register/business-account', name: 'register.business', component: BusinessRegister.Index },
            { path: '/user/invoice/edit', name: 'user.invoice.edit', component: EditInvoice },
            {
                path: '/airport-transfers',
                name: 'airport-transfers.index',
                component: AirportTransfersPage.Index,
                meta: {
                    title: 'offer_types.airport_transfers',
                    icon: 'bus',
                },
            },
            {
                path: '/airport-transfers/search',
                name: 'airport-transfers.search',
                component: AirportTransfersPage.Search,
                meta: {
                    title: 'offer_types.airport_transfers',
                    icon: 'bus',
                },
            },
            {
                path: '/airport-transfers/departures',
                name: 'airport-transfers.departures',
                component: AirportTransfersPage.Departures,
                meta: {
                    title: 'offer_types.airport_transfers',
                    icon: 'bus',
                },
            },
            {
                path: '/airport-transfers/returns',
                name: 'airport-transfers.returns',
                component: AirportTransfersPage.Returns,
                meta: {
                    title: 'offer_types.airport_transfers',
                    icon: 'bus',
                },
            },
            {
                path: '/airport-transfers/passengers',
                name: 'airport-transfers.passengers',
                component: AirportTransfersPage.Passengers,
                meta: {
                    title: 'offer_types.airport_transfers',
                    icon: 'bus',
                },
            },
            {
                path: '/airport-transfers/options',
                name: 'airport-transfers.options',
                component: AirportTransfersPage.Options,
                meta: {
                    title: 'offer_types.airport_transfers',
                    icon: 'bus',
                },
            },
            {
                path: '/airport-transfers/summary',
                name: 'airport-transfers.summary',
                component: AirportTransfersPage.Summary,
                meta: {
                    title: 'offer_types.airport_transfers',
                    icon: 'bus',
                },
            },
            {
                path: '/airport-transfers/confirmation/:orderId?',
                name: 'airport-transfers.confirmation',
                component: AirportTransfersPage.Confirmation,
                meta: {
                    title: 'offer_types.airport_transfers',
                    icon: 'bus',
                },
            },
            {
                path: '/business-taxi',
                name: 'business-taxi.index',
                component: BusinessTaxiPage.Index,
                meta: {
                    title: 'offer_types.business_taxi',
                    icon: 'car',
                },
            },
            {
                path: '/business-taxi/search',
                name: 'business-taxi.search',
                component: BusinessTaxiPage.Search,
                meta: {
                    title: 'offer_types.business_taxi',
                    icon: 'car',
                },
            },
            {
                path: '/business-taxi/vehicles',
                name: 'business-taxi.vehicles',
                component: BusinessTaxiPage.Vehicles,
                meta: {
                    title: 'offer_types.business_taxi',
                    icon: 'car',
                },
            },
            {
                path: '/business-taxi/passengers',
                name: 'business-taxi.passengers',
                component: BusinessTaxiPage.Passengers,
                meta: {
                    title: 'offer_types.business_taxi',
                    icon: 'car',
                },
            },
            {
                path: '/business-taxi/addresses',
                name: 'business-taxi.addresses',
                component: BusinessTaxiPage.Addresses,
                meta: {
                    title: 'offer_types.business_taxi',
                    icon: 'car',
                },
            },
            {
                path: '/business-taxi/options',
                name: 'business-taxi.options',
                component: BusinessTaxiPage.Options,
                meta: {
                    title: 'offer_types.business_taxi',
                    icon: 'car',
                },
            },
            {
                path: '/business-taxi/summary',
                name: 'business-taxi.summary',
                component: BusinessTaxiPage.Summary,
                meta: {
                    title: 'offer_types.business_taxi',
                    icon: 'car',
                },
            },
            {
                path: '/business-taxi/confirmation',
                name: 'business-taxi.confirmation',
                component: BusinessTaxiPage.OrderConfirmation,
                meta: {
                    title: 'offer_types.business_taxi',
                    icon: 'car',
                },
            },
            {
                path: '/business-taxi/confirmation/:orderId',
                name: 'business-taxi.confirmation-post-payment',
                component: BusinessTaxiPage.Confirmation,
                meta: {
                    title: 'offer_types.business_taxi',
                    icon: 'car',
                },
            },
            {
                path: '/business-taxi/payment-error',
                name: 'business-taxi.payment-error',
                component: BusinessTaxiPage.PaymentError,
                meta: {
                    title: 'offer_types.business_taxi',
                    icon: 'car',
                },
            },
            {
                path: '/smart-taxi',
                name: 'smart-taxi.index',
                component: FamilyAirportTaxiPage.Index,
                meta: {
                    title: 'offer_types.family_airport_taxi',
                    icon: 'bus-car',
                },
                beforeEnter: (to, from, next) => {
                    preventCompany(next);
                },
            },
            {
                path: '/smart-taxi/search',
                name: 'smart-taxi.search',
                component: FamilyAirportTaxiPage.Search,
                meta: {
                    title: 'offer_types.family_airport_taxi',
                    icon: 'bus-car',
                },
                beforeEnter: (to, from, next) => {
                    preventCompany(next);
                },
            },
            {
                path: '/smart-taxi/vehicles',
                name: 'smart-taxi.vehicles',
                component: FamilyAirportTaxiPage.Vehicles,
                meta: {
                    title: 'offer_types.family_airport_taxi',
                    icon: 'bus-car',
                },
                beforeEnter: (to, from, next) => {
                    preventCompany(next);
                },
            },
            {
                path: '/smart-taxi/passengers',
                name: 'smart-taxi.passengers',
                component: FamilyAirportTaxiPage.Passengers,
                meta: {
                    title: 'offer_types.family_airport_taxi',
                    icon: 'bus-car',
                },
                beforeEnter: (to, from, next) => {
                    preventCompany(next);
                },
            },
            {
                path: '/smart-taxi/addresses',
                name: 'smart-taxi.addresses',
                component: FamilyAirportTaxiPage.Addresses,
                meta: {
                    title: 'offer_types.family_airport_taxi',
                    icon: 'bus-car',
                },
                beforeEnter: (to, from, next) => {
                    preventCompany(next);
                },
            },
            {
                path: '/smart-taxi/options',
                name: 'smart-taxi.options',
                component: FamilyAirportTaxiPage.Options,
                meta: {
                    title: 'offer_types.family_airport_taxi',
                    icon: 'bus-car',
                },
                beforeEnter: (to, from, next) => {
                    preventCompany(next);
                },
            },
            {
                path: '/smart-taxi/summary',
                name: 'smart-taxi.summary',
                component: FamilyAirportTaxiPage.Summary,
                meta: {
                    title: 'offer_types.family_airport_taxi',
                    icon: 'bus-car',
                },
                beforeEnter: (to, from, next) => {
                    preventCompany(next);
                },
            },
            {
                path: '/smart-taxi/confirmation',
                name: 'smart-taxi.confirmation',
                component: FamilyAirportTaxiPage.OrderConfirmation,
                meta: {
                    title: 'offer_types.family_airport_taxi',
                    icon: 'bus-car',
                },
                beforeEnter: (to, from, next) => {
                    preventCompany(next);
                },
            },
            {
                path: '/smart-taxi/confirmation/:orderId',
                name: 'smart-taxi.confirmation-post-payment',
                component: FamilyAirportTaxiPage.Confirmation,
                meta: {
                    title: 'offer_types.family_airport_taxi',
                    icon: 'bus-car',
                },
                beforeEnter: (to, from, next) => {
                    preventCompany(next);
                },
            },
            {
                path: '/smart-taxi/payment-error',
                name: 'smart-taxi.payment-error',
                component: FamilyAirportTaxiPage.PaymentError,
                meta: {
                    title: 'offer_types.family_airport_taxi',
                    icon: 'bus-car',
                },
                beforeEnter: (to, from, next) => {
                    preventCompany(next);
                },
            },
            {
                path: '/coaches',
                name: 'coaches.index',
                component: CoachesPage.Index,
                meta: {
                    title: 'offer_types.coaches',
                    icon: 'coach',
                },
            },
            {
                path: '/coaches/transfer-type',
                name: 'coaches.transfer-type',
                component: CoachesPage.TransferType,
                meta: {
                    title: 'offer_types.coaches',
                    icon: 'coach',
                },
            },
            {
                path: '/coaches/additional-options',
                name: 'coaches.additional-options',
                component: CoachesPage.AdditionalOptions,
                meta: {
                    title: 'offer_types.coaches',
                    icon: 'coach',
                },
            },
            {
                path: '/coaches/contact',
                name: 'coaches.contact',
                component: CoachesPage.Contact,
                meta: {
                    title: 'offer_types.coaches',
                    icon: 'coach',
                },
            },
            {
                path: '/coaches/summary',
                name: 'coaches.summary',
                component: CoachesPage.Summary,
                meta: {
                    title: 'offer_types.coaches',
                    icon: 'coach',
                },
            },
            {
                path: '/coaches/:code',
                name: 'coaches.index-with-code',
                component: CoachesPage.Index,
                meta: {
                    title: 'offer_types.coaches',
                    icon: 'coach',
                },
            },
            {
                path: '/business-travel-management',
                name: 'business-travel-management.index',
                component: BusinessTravelManagementPage.Index,
                meta: {
                    title: 'offer_types.business_travel_management',
                    icon: 'plane',
                },
            },
            {
                path: '/business-travel-management/travel-options',
                name: 'business-travel-management.travel-options',
                component: BusinessTravelManagementPage.TravelOptions,
                meta: {
                    title: 'offer_types.business_travel_management',
                    icon: 'plane',
                },
            },
            {
                path: '/business-travel-management/contact',
                name: 'business-travel-management.contact',
                component: BusinessTravelManagementPage.Contact,
                meta: {
                    title: 'offer_types.business_travel_management',
                    icon: 'plane',
                },
            },
            {
                path: '/business-travel-management/summary',
                name: 'business-travel-management.summary',
                component: BusinessTravelManagementPage.Summary,
                meta: {
                    title: 'offer_types.business_travel_management',
                    icon: 'plane',
                },
            },
            {
                path: '/berbus',
                name: 'berbus.index',
                component: BerbusPage.Index,
                meta: {
                    title: 'offer_types.berbus',
                    icon: 'bus-car',
                },
            },
            {
                path: '/berbus/address',
                name: 'berbus.address',
                component: BerbusPage.Address,
                meta: {
                    title: 'offer_types.berbus',
                    icon: 'bus-car',
                },
            },
            {
                path: '/berbus/vehicles',
                name: 'berbus.vehicles',
                component: BerbusPage.Vehicles,
                meta: {
                    title: 'offer_types.berbus',
                    icon: 'bus-car',
                },
            },
            {
                path: '/berbus/passengers',
                name: 'berbus.passengers',
                component: BerbusPage.Passengers,
                meta: {
                    title: 'offer_types.berbus',
                    icon: 'bus-car',
                },
            },
            {
                path: '/berbus/options',
                name: 'berbus.options',
                component: BerbusPage.Options,
                meta: {
                    title: 'offer_types.berbus',
                    icon: 'bus-car',
                },
            },
            {
                path: '/berbus/summary',
                name: 'berbus.summary',
                component: BerbusPage.Summary,
                meta: {
                    title: 'offer_types.berbus',
                    icon: 'bus-car',
                },
            },
            {
                path: '/berbus/confirmation',
                name: 'berbus.confirmation',
                component: BerbusPage.OrderConfirmation,
                meta: {
                    title: 'offer_types.berbus',
                    icon: 'bus-car',
                },
            },
            {
                path: '/berbus/confirmation/:orderId?',
                name: 'business-taxi.confirmation',
                component: BerbusPage.Confirmation,
                meta: {
                    title: 'offer_types.berbus',
                    icon: 'bus-car',
                },
            },
            {
                path: '/berbus/payment-error',
                name: 'berbus.payment-error',
                component: BerbusPage.PaymentError,
                meta: {
                    title: 'offer_types.berbus',
                    icon: 'bus-car',
                },
            },
            {
                path: '/tours/:code/:dateFrom?/:dateTo?',
                name: 'tours.tour',
                component: Tours.Tour,
                meta: {
                    title: 'offer_types.tours',
                    icon: 'coach',
                },
            },
            {
                path: '/user/orders/:offerType/:orderNumber',
                name: 'users_orders_show',
                component: Orders.Show,
                meta: {
                    title: 'orders.title',
                },
                beforeEnter: (to, from, next) => {
                    preventNotLoggedIn(next);
                    if (to.params.offerType === 'fat') {
                        preventCompany(next);
                    } else {
                        next();
                    }
                },
            },
            {
                path: '/user/orders/:offerType',
                name: 'users_orders',
                component: Orders.Index,
                meta: {
                    title: 'orders.title',
                },
                beforeEnter: (to, from, next) => {
                    preventNotLoggedIn(next);
                    if (to.params.offerType === 'fat') {
                        preventCompany(next);
                    } else {
                        next();
                    }
                },
            },
            {
                path: '/user/data',
                name: 'user_data',
                component: UserData,
                meta: {
                    title: 'user_data.header',
                },
                beforeEnter: (to, from, next) => {
                    preventNotLoggedIn(next);
                },
            },
        ],
    },
];
